export default [
  { name: '來電洽詢', imgSrc: '', subTitle: '', section: 'contact-info', svgSrc: '', offset: -100 },
  { name: '立即預約', imgSrc: '', subTitle: '', section: 'contact', svgSrc: '', offset: -100 },
  { name: '地圖導航', imgSrc: '', subTitle: '', section: 'google-map', svgSrc: '', mobileOffset: 0 },
]
